import { Form, Input, Select, Button, Card, Spin, DatePicker, Typography } from "antd";
import { UserService } from "../../services/user/UserService";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./User.css";
import "./CreateUser.css";
import queryString from "query-string";
import { Constants } from "../../data/constants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Translation } from "react-i18next";
import i18next from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import { HttpService } from "../../utils/HttpService";

dayjs.extend(customParseFormat);
class CreateUserForm extends Component {
  userService = new UserService();
  accountGroupService = new AccountGroupService();

  constructor(props) {
    super(props);
    this.httpService = new HttpService();

    this.props.context.setCurrentComponent("createUsers");
    this.constants = new Constants();
    this.state = {
      confirmDirty: false,
      validateStatus: null,
      user: {},
      isFetching: false,
      formLayout: "inline",
      IsAgent: false,
      prefix: this.constants.PREFIX_NUM,
      allAgentStatus: [],
      flagKeyDown:false,
      validateStatusForODS:null,
      agentGroups: [],
      onlineAvailability: 0,
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
    this.state.user.userType = "ADMIN";
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const user = {};
    user["userEmail"] = values["email"] ? values["email"] : "";
    user["userFullname"] = values["name"] ? values["name"] : "";
    user["userNumber"] = values["number"] ? values["number"] : "";
    user["userNumberAlph"] = values["number"] ? values["number"] : "";

    let agentGroups = await this.getAgentGroups();
    this.setState({
      agentGroups: agentGroups ? agentGroups.ivrList : [],
      onlineAvailability: agentGroups ? agentGroups.cfgList[0] : 0,
    });

    try {
      this.setState({ isFetching: true });
      let allAgentStatus = await this.userService.getAllAgentStatusService(
        this.props.context.session_id
      );
      let addStatusArabic = allAgentStatus.ivrList;
      addStatusArabic.forEach((elem) => {
        if (elem.status == "ONLINE") elem.statusAr = "متصل";
        if (elem.status == "OFFLINE") elem.statusAr = "غير متصل";
        if (elem.status == "AUX") elem.statusAr = "عطل في الجهاز";
        if (elem.status == "BREAK") elem.statusAr = "استراحة";
      });
      this.setState({
        allAgentStatus: addStatusArabic,
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAgentGroups() {
    try {
      let data = await this.accountGroupService.getAccountGroupsByType(
        this.props.context.session_id,
        this.constants.groupTypeList["SXG"]
      );
      return data;
    } catch (e) {
      handleError(e);
    }
  }

  handleDropdownChange(value) {
    let { user } = this.state;
    user.userType = value;
    if (value === "ADMIN") {
      this.setState({ user: user, IsAgent: false });
    } else if (value === "AGENT") {
      this.setState({ user: user, IsAgent: true });
    }
  }
  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.userService = new UserService();
          const selectedDate = values["userBirthdate"]
            .format("YYYY")
            .toString()
            .split("T")[0];
          const todaysDate = dayjs()
            .endOf("day")
            .format("YYYY")
            .toString()
            .split("T")[0];
          if (todaysDate - selectedDate >= 18) {
            values["userBirthdate"] = values["userBirthdate"]
              .format()
              .toString()
              .split("T")[0];
          } else {
            throw new Error(i18next.t("user age must be at least 18"));
          }

          values["userNumber"] =
            this.props.context.user.userNumberType === "alphanumeric" &&
            this.state.user.userType !== "ADMIN"
              ? values["userNumberAlph"]
              : values["userNumber"];

          if (this.state.IsAgent === true) {
            values["cfg"] = [
              {
                key: "AGENT_NUMBER",
                value:
                  this.props.context.user.userNumberType === "alphanumeric"
                    ? values["userNumberAlph"]
                    : values["userNumber"],
                configCategory: "CTI",
              },
              {
                key: "AGENT_STATUS",
                value: values["cfgUserStatus"],
                configCategory: "CTI",
              },
            ];
            values["sxgId"] = values["agentGroup"] ? values["agentGroup"] : null;
          } else {
            values["cfg"] = [];
          }

          let data = await this.userService.createUser(
            this.props.context.session_id,
            values
          );

          if (this.state.IsAgent === true && values["agentGroup"] && false) {
            await this.userService.assignUserGroup(
              this.props.context.session_id,
              values["agentGroup"],
              data.id
            );
          }
          showSuccessToast(i18next.t(data.statusMsg));
          this.setState({ loading: false });
          this.props.form.resetFields();
          this.navigateAfterSuccessCreation();
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  handlePrefixSelector(e) {
    let value = e;
    this.setState({ prefix: value });
  }

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("userPassword")) {
      callback(i18next.t("Two passwords that you enter is inconsistent!"));
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  onFocus = (event) => {
    if (event.target.autocomplete) {
      event.target.autocomplete = "whatever";
    }
  };

  navigateAfterSuccessCreation = () => {
    this.constants.navigateToInvitations ? this.props.history.push("/home/users/invitations/") : this.props.history.push("/home/users/");
   };


  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { Option } = Select;
    let { isFetching, allAgentStatus, agentGroups, onlineAvailability } =
      this.state;
    const prefixSelector = getFieldDecorator("prefix", {
      initialValue: this.constants.PREFIX_NUM,
    })(
      <Select
        style={{ width: 70 }}
        onChange={(e) => this.handlePrefixSelector(e)}
      >
        <Option value="010">010</Option>
        <Option value="011">011</Option>
        <Option value="012">012</Option>
        <Option value="015">015</Option>
      </Select>
    );

    const agentStatusOptions = allAgentStatus.map((opt) => (
      <Option
        key={opt.status}
        value={opt.status}
        // disabled={
        //   onlineAvailability <= 0 && opt.status === "ONLINE" ? true : false
        // }
      >
        {this.state.lang == "ar" ? opt.statusAr : opt.statusDescription}

        {/* {opt.statusDescription} */}
      </Option>
    ));

    const agentGroupsOptions = agentGroups.map((opt) => (
      <Option key={opt.groupId} value={opt.groupId}>
        {opt.groupName}
      </Option>
    ));

    const disabledDate = (current) => {
      // Can not select days after today
      return current > dayjs().endOf("day");
    };
    return (
      <Translation>
        {(t) => (
          <Page title={t("Create User")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <Form className="form-style" {...formItemLayout}>
                <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType !==
                          "alphanumeric" || this.state.user.userType === "ADMIN"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                    validateStatus={this.state.validateStatus}
                    help={
                      this.state.validateStatus == "error"
                        ? (this.state.validateStatusForODS=="errorVodafone" ? i18next.t("Please Enter Vodafone Number") :i18next.t("Mobile number is not valid"))
                        : ""
                    }
                    hasFeedback={this.state.validateStatus}
                  >
                    {getFieldDecorator("userNumber", {
                      initialValue: this.state.user.userNumber,
                      rules: [
                        {
                          type: "string",
                          message: t("Mobile number is not valid"),
                          min: 12,
                          max: 12,
                          pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType !==
                              "alphanumeric" ||
                            this.state.user.userType === "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter user number"),
                        },
                      ],
                    })(
                      <Input
                        maxLength={12}
                        placeholder="201XXXXXXXXX"
                        id="validating"
                        onMouseLeave={async (e) => {
                            
                          if(this.state.flagKeyDown){
                          if (
                            !/^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(
                              e.target.value
                            ) ||
                            e.target.value.length < 12
                          ) {
                            this.setState({ validateStatus: "error" });
                            return;
                          }
                          if(!this.constants.TESTING){
                            if (e.target.value.length == 12) {
                              this.setState({ validateStatus: "validating" });
                              this.setState({flagKeyDown:false})
                              let response = await this.userService.validateUserNumber(this.props.context.session_id,e.target.value)
                              if (response == null) {
                                this.setState({ validateStatus: "error",validateStatusForODS:"errorVodafone" });
                              } else {
                                if (response.exceptionCode == 0 || response.exceptionCode=="0") {
                                  this.setState({ validateStatus: "success" });
                                } else {
                                  this.setState({ validateStatus: "error",validateStatusForODS:"errorVodafone" });
                                }
                              }
                            }
                          }else{
                            this.setState({ validateStatus: "success" });

                          }
                        }
                       
                        }}
                        onChange={async (e) => {
                           this.setState({flagKeyDown:true}) 
                          if (
                            !/^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(
                              e.target.value
                            ) ||
                            e.target.value.length < 12
                          ) {
                            this.setState({ validateStatus: "error" });
                            return;
                          }
                          this.setState({validateStatus:null})
                          // if (e.target.value.length == 12) {
                          //   this.setState({ validateStatus: "validating" });
                          //   let response = await this.httpService.getXml(
                          //     this.constants.serverTibcoMNP +
                          //       "ODS/IVR/GetAggregatedContractProfiles?IdentifierNumber=" +
                          //       `${e.target.value}` +
                          //       "&IdentifierType=1&RetrieveAggregatedUsageFlag=&RetrieveGrantedUsageFlag='"
                          //   );
                          //   if (response == null) {
                          //     this.setState({ validateStatus: "error" });
                          //   } else {
                          //     if (response.code == 0) {
                          //       this.setState({ validateStatus: "success" });
                          //     } else {
                          //       this.setState({ validateStatus: "error" });
                          //     }
                          //   }
                          // }
                        }}
                      />
                    )}
                  </Form.Item>


                  <Form.Item label={t("Email")} {...formItemLayout}>
                    {getFieldDecorator("userEmail", {
                      initialValue: this.state.user.userEmail,

                      rules: [
                        {
                          type: "email",
                          message: t("The input is not valid E-mail!"),
                        },
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user email"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("Full Name")} {...formItemLayout}>
                    {getFieldDecorator("userFullname", {
                      initialValue: this.state.user.userFullname,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user full name"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("Birthdate")} {...formItemLayout}>
                    {getFieldDecorator("userBirthdate", {
                      initialValue: this.state.user.userBirthdate,

                      rules: [
                        {
                          required: true,
                          message: t("Please enter user birthdate"),
                        },
                      ],
                    })(
                      <DatePicker
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        locale={this.state.lang === "ar" ? ar : en}
                      />
                    )}
                  </Form.Item>

                  <Form.Item label={t("Gender")} {...formItemLayout}>
                    {getFieldDecorator("userGender", {
                      initialValue: "M",

                      rules: [
                        {
                          required: true,
                          message: t("Please select user gender"),
                        },
                      ],
                    })(
                      <Select placeholder={t("Select ")}>
                        <Option value="M">{t("Male")}</Option>
                        <Option value="F"> {t("Female")}</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label={t("User Name")} {...formItemLayout}>
                    {getFieldDecorator("userName", {
                      initialValue: this.state.user.userName,

                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user name"),
                        },
                      ],
                    })(<Input autoComplete="off" onFocus={this.onFocus} />)}
                  </Form.Item>

                  <Form.Item label={t("UserType")} {...formItemLayout}>
                    {getFieldDecorator("userType", {
                      initialValue: "ADMIN",
                      rules: [
                        {
                          required: true,
                          message: t("Please input Account  Category"),
                        },
                      ],
                    })(
                      <Select
                        onChange={(value) => this.handleDropdownChange(value)}
                      >
                        <Option value="ADMIN">{t("Admin")}</Option>
                        <Option value="AGENT">{t("Agent")}</Option>
                      </Select>
                    )}
                  </Form.Item>

                  {this.state.IsAgent && (
                    <Form.Item 
                      wrapperCol={{ span: 14, offset: 6 }}
                      style={{ marginBottom: 5, marginTop: 0 }}
                      className="agent-disclaimer-item"
                    >
                      <Typography.Text style={{ color: "#d73a31", fontSize: 16, display: "block", wordBreak: "break-word" }}>
                        {t("Please note that the agent will receive their username and password via SMS. They will not be added to the call flow until they log in.")}
                      </Typography.Text>
                    </Form.Item>
                  )}

                  <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType ===
                          "alphanumeric" && this.state.user.userType === "AGENT"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("userNumberAlph", {
                      initialValue: this.state.user.userNumber,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                          pattern: "^[a-zA-Z0-9_@$.*]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType ===
                              "alphanumeric" &&
                            this.state.user.userType !== "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter user number"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  {/* <Form.Item
                name="userPassword"
                label={t("Password"
                {...formItemLayout}
                hasFeedback
              >
                {getFieldDecorator("userPassword", {
                  initialValue: this.state.user.userPassword,
                  rules: [
                    {
                      required: true,
                      message: "Please enter user password",
                    },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(
                  <Input.Password autoComplete="off" onFocus={this.onFocus} />
                )}
              </Form.Item> */}
                  {/* 
              <Form.Item label={t("Confirm Password" hasFeedback>
                {getFieldDecorator("confirm", {
                  rules: [
                    {
                      required: true,
                      message:  t("Please confirm your password!",
                    },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(
                  <Input.Password
                    onBlur={this.handleConfirmBlur}
                    autoComplete="off"
                    onFocus={this.onFocus}
                  />
                )}
              </Form.Item> */}

                  <Form.Item
                    label={t("Status")}
                    {...formItemLayout}
                    style={{
                      display:
                        this.state.user.userType !== "ADMIN" ? "block" : "none",
                    }}
                  >
                    {getFieldDecorator("cfgUserStatus", {
                      // initialValue: onlineAvailability > 0 ? "ONLINE" : "OFFLINE",
                      initialValue: "ONLINE",

                      rules: [
                        {
                          required:
                            this.state.user.userType !== "ADMIN" ? true : false,
                          message: t("Please select user status"),
                        },
                      ],
                    })(<Select>{agentStatusOptions}</Select>)}
                  </Form.Item>

                  <Form.Item
                    label={t("Group")}
                    {...formItemLayout}
                    style={{
                      display:
                        this.state.user.userType !== "ADMIN" ? "block" : "none",
                    }}
                  >
                    {getFieldDecorator("agentGroup", {
                      initialValue: "",

                      rules: [
                        {
                          message: t("Please select agent group"),
                        },
                      ],
                    })(
                      <Select style={{ width: "100%" }}>
                        {agentGroupsOptions}
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                      disabled={this.state.validateStatus != "success"}
                    >
                      {t("Submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateUserForm))
);
